import { GET_STARTED_KEY } from '../../constants/keys.const';

const namespaced = true;

const getInitialState = ()=>{
    return {
    products: [],
    productsPromise: null,
    selectedProduct: null,
    cartBoxes: {},
    state: { blocking: false, message: '' },


};
}

const state = getInitialState();


const getters = {
    products: state => state.products,
    selectedProduct: state => state.selectedProduct,
    cartBoxes: state => Object.values(state.cartBoxes),
    cartBoxesById: state => state.cartBoxes,
    totalCartBoxesQuantity: state => Object.values(state.cartBoxes).reduce((acc, cur) => acc + cur.quantity,
        0),
    isBlocking: s => s.state.blocking,

};

const mutations = {
    SET_PRODUCTS: (state, payload) => {
        state.products = payload.map(product => {
            return {
                ...product,
                images: product.media.find(media => media.type === 'image') || { media: { original: '' }}
            };
        });
    },
    SET_PRODUCTS_PROMISE: (state, payload) => {
        state.productsPromise = payload;
    },
    SET_CART_PRODUCT: (state, payload) => {

        if (state.cartBoxes[payload.id]) {

            // Update the quantity of the existing product
            state.cartBoxes[payload.id].quantity = payload.quantity;
        } else {

            // Add the new product to cartBoxes
            state.cartBoxes = {
                ...state.cartBoxes,
                [payload.id]: payload
            };
        }

    },
    RESET_CART_PRODUCT: state => {
        state.cartBoxes = {};
    },
    SET_SELECTED_PRODUCT: (state, payload) => {
        state.selectedProduct = payload;
    },
    SET_BLOCKING(state, { value, message = '' }) {
      state.state.blocking = value;
      state.state.message = message;
    },
    RESET_STATE: state => {
        Object.assign(state, getInitialState());
    }

};

const actions = {
    GET_PRODUCTS: async context => {
        if (context.state.products.length) {
            return context.state.products;
        }

        if (context.state.productsPromise) {
            return context.state.productsPromise;
        }

        const promise = window.api.call('get-products')
            .then(response => {
                context.commit('SET_PRODUCTS', response.data.data);

                return context.state.products;
            })
            .catch(error => {
                console.error('Error fetching products:', error);
                context.commit('SET_PRODUCTS_PROMISE', null);

                return undefined;
            });

        context.commit('SET_PRODUCTS_PROMISE', promise);

        return promise;
    }
};

export default {
    namespaced,
    state,
    mutations,
    actions,
    getters
};
